import React from 'react'
import classnames from 'classnames'
import { Heading } from '@myxplor/ui'

import RecordDisplay from '../record-display'
import { pluralise } from '../../text-transformations'

import DisplayRecordItem from './item'
import './record-display-list.css'



const RecordDisplayList = ({
  name = 'Record',
  records = [],
  actionButtonsComponent,
  recordBase,
  filtering = false,
  level1 = [],
  level2 = [],
  showRaw = false,
  hideHeading = false,
  pending,
  recordBadgesComponent,
  className,
  activeLabel = 'Active ',
  topContent = null
}) => (
  <div
    className={classnames({
      'recordDisplayList--wrapper': true,
      [className]: className
    })}
  >
    {
      hideHeading ?
        null :
        <Heading small compact>
          {pluralise(records.length, `${filtering ? activeLabel : ' '}${name}`)}
        </Heading>
    }

    {
      topContent
    }

    <ol>
      {
        records.map((record, i) => (
          <DisplayRecordItem
            key={'record-item' + i}
            count={1 + i}
            name={name}
            record={record}
            pending={pending}
            recordsTotal={records.length}
            actionButtonsComponent={actionButtonsComponent}
            recordBadgesComponent={recordBadgesComponent}
          >
            <RecordDisplay
              record={recordBase ? record[recordBase] : record}
              level1={level1}
              level2={level2}
              showRaw={showRaw}
            />
          </DisplayRecordItem>
        ))
      }
    </ol>
  </div>
)

export default RecordDisplayList



// WEBPACK FOOTER //
// ./src/ui/record-display-list/container.jsx